import { Controller } from "@hotwired/stimulus";
import { saveModelingControls } from "../scenario_modeling/save_controls";

export default class extends Controller {
  static values = {
    saveUrl: String,
  };

  async download(event) {
    event.preventDefault();

    const href = event.currentTarget.getAttribute("href");
    if (!href || this._inFlight) return;

    this._inFlight = true;

    try {
      if (this.saveUrlValue) {
        await saveModelingControls(this.saveUrlValue);
      }

      window.location.assign(href);
    } catch (error) {
      this._inFlight = false;
      window.alert(error.message || "Could not save your modeling changes. Please try again.");
    }
  }
}
